
interface RadioButtonPaymentsFilterProps {
  statusFilter: string;
  showFines: boolean;
  handleStatusChange: (status: string) => void;
  handleShowFines: () => void;
}

export function RadioButtonPaymentsFilter({
  statusFilter,
  showFines,
  handleStatusChange,
  handleShowFines,
}: RadioButtonPaymentsFilterProps) {
  return (
    <div className="flex flex-wrap justify-center gap-4 mb-4 mt-4">
      {/* Todas */}
      <div className="flex items-center">
        <input
          type="radio"
          name="filter"
          id="showAll"
          className="text-blue-600 focus:ring-blue-500"
          checked={statusFilter === "" && !showFines}
          onChange={() => handleStatusChange("")}
        />
        <label htmlFor="showAll" className="ml-2 text-sm font-medium text-gray-700">
          Todas
        </label>
      </div>

      {/* Pendente */}
      <div className="flex items-center">
        <input
          type="radio"
          name="filter"
          id="showPending"
          className="text-blue-600 focus:ring-blue-500"
          checked={statusFilter === "PENDING" && !showFines}
          onChange={() => handleStatusChange("PENDING")}
        />
        <label htmlFor="showPending" className="ml-2 text-sm font-medium text-gray-700">
          Pendente
        </label>
      </div>

      {/* Recebido */}
      <div className="flex items-center">
        <input
          type="radio"
          name="filter"
          id="showReceived"
          className="text-blue-600 focus:ring-blue-500"
          checked={
            ["RECEIVED", "CONFIRMED", "RECEIVED_IN_CASH"].includes(statusFilter) && !showFines
          }
          onChange={() => handleStatusChange("RECEIVED")}
        />
        <label htmlFor="showReceived" className="ml-2 text-sm font-medium text-gray-700">
          Recebido
        </label>
      </div>

      {/* Atrasado */}
      <div className="flex items-center">
        <input
          type="radio"
          name="filter"
          id="showOverdue"
          className="text-blue-600 focus:ring-blue-500"
          checked={statusFilter === "OVERDUE" && !showFines}
          onChange={() => handleStatusChange("OVERDUE")}
        />
        <label htmlFor="showOverdue" className="ml-2 text-sm font-medium text-gray-700">
          Atrasado
        </label>
      </div>

      {/* Inativo */}
      <div className="flex items-center">
        <input
          type="radio"
          name="filter"
          id="showInactive"
          className="text-blue-600 focus:ring-blue-500"
          checked={statusFilter === "Inativo" && !showFines}
          onChange={() => handleStatusChange("Inativo")}
        />
        <label htmlFor="showInactive" className="ml-2 text-sm font-medium text-gray-700">
          Removida
        </label>
      </div>

      <div className="flex items-center">
        <input
          type="radio"
          name="filter"
          id="showNegativations"
          className="text-blue-600 focus:ring-blue-500"
          checked={statusFilter === "DUNNING" && !showFines}
          onChange={() => handleStatusChange("DUNNING")}
        />
        <label htmlFor="showNegativations" className="ml-2 text-sm font-medium text-gray-700">
          Negativações
        </label>
      </div>

      {/* Multas de Trânsito */}
      <div className="flex items-center">
        <input
          type="radio"
          name="filter"
          id="showFines"
          className="text-blue-600 focus:ring-blue-500"
          checked={showFines}
          onChange={handleShowFines}
        />
        <label htmlFor="showFines" className="ml-2 text-sm font-medium text-gray-700">
          Multas de Trânsito
        </label>
      </div>
    </div>
  );
}